import { render, staticRenderFns } from "./addIntegralCommodity.vue?vue&type=template&id=9d5f386c&scoped=true"
import script from "./addIntegralCommodity.vue?vue&type=script&lang=js"
export * from "./addIntegralCommodity.vue?vue&type=script&lang=js"
import style0 from "./addIntegralCommodity.vue?vue&type=style&index=0&id=9d5f386c&prod&scoped=true&lang=css"
import style1 from "./addIntegralCommodity.vue?vue&type=style&index=1&id=9d5f386c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5f386c",
  null
  
)

export default component.exports